import { Property } from "./interfaces";

export const codProcedimiento: Property = {
  title: "Código de Procedimiento",
  type: "string",
};
